import React, { useMemo } from 'react';

import { Platform } from 'react-native';

import { useSelector } from 'react-redux';

import EpgProgramListMobileSkeletonLoading from 'assets/images/animation/epg_list_skeleton_mobile.svg';
import EpgProgramListTabletSkeletonLoading from 'assets/images/animation/epg_list_skeleton_tablet.svg';
import EpgProgramListDesktopSkeletonLoading from 'assets/images/animation/epg_list_skeleton_web.svg';

import { selectLayoutConfig } from 'store/config/selectors';

import {
    heightPercentageToDP,
    isTablet,
    isWeb,
    widthPercentageToDP,
} from 'utils/responsiveness';

import SkeletonLoading from 'components/SkeletonLoading';

const EpgProgramListSkeleton = () => {
    const { background } = useSelector(selectLayoutConfig);

    const SkeletonLoadingComponent = useMemo(() => {
        if (isWeb) {
            return EpgProgramListDesktopSkeletonLoading;
        }

        if (isTablet) {
            return EpgProgramListTabletSkeletonLoading;
        }

        return EpgProgramListMobileSkeletonLoading;
    }, []);

    return (
        <SkeletonLoading
            isScreenSkeleton={false}
            SkeletonLoadingComponent={SkeletonLoadingComponent}
            backgroundColor={background}
            width={Platform.select({
                web: 720,
                default: widthPercentageToDP(360, 960),
            })}
            height={Platform.select({
                web: 1024,
                default: heightPercentageToDP(444, 404),
            })}
        />
    );
};

export default EpgProgramListSkeleton;
